import { render, staticRenderFns } from "./StatsContainerB2C.vue?vue&type=template&id=0b79284e&scoped=true&"
import script from "./StatsContainerB2C.vue?vue&type=script&lang=js&"
export * from "./StatsContainerB2C.vue?vue&type=script&lang=js&"
import style0 from "./StatsContainerB2C.vue?vue&type=style&index=0&id=0b79284e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79284e",
  null
  
)

export default component.exports